var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3337 7.33463H12.667V12.668H7.33366V15.3346H12.667V20.668H15.3337V15.3346H20.667V12.668H15.3337V7.33463ZM14.0003 0.667969C6.65366 0.667969 0.666992 6.65463 0.666992 14.0013C0.666992 21.348 6.65366 27.3346 14.0003 27.3346C21.347 27.3346 27.3337 21.348 27.3337 14.0013C27.3337 6.65463 21.347 0.667969 14.0003 0.667969ZM14.0003 24.668C8.12033 24.668 3.33366 19.8813 3.33366 14.0013C3.33366 8.1213 8.12033 3.33464 14.0003 3.33464C19.8803 3.33464 24.667 8.1213 24.667 14.0013C24.667 19.8813 19.8803 24.668 14.0003 24.668Z",
    fill: "#2A5578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAssessment);
export default __webpack_public_path__ + "static/media/add-assessment.1a86db22fa78a67e51b871b1579fe946.svg";
export { ForwardRef as ReactComponent };